import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

export default function Checkout() {
  const location = useLocation()
  const navigate = useNavigate()
  const { dress, fabric, sleeve, length, totalPrice, measurements } = location.state || {}
  
  const deliveryCharges = 300
  const grandTotal = (totalPrice || 6000) + deliveryCharges

  const [customer, setCustomer] = useState({
    name: '',
    email: '',
    phone: '',
    address: ''
  })
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setCustomer({ ...customer, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    
    const order = {
      orderId: 'ORD-' + Date.now(),
      customer,
      dress,
      fabric,
      sleeve,
      length,
      totalPrice: totalPrice || 6000,
      deliveryCharges: deliveryCharges,
      grandTotal: grandTotal,
      measurements,
      status: 'Received'
    }
    
    try {
      await fetch('https://script.google.com/macros/s/AKfycbyjUfxj6PzKWpunCWhswW8bPEKf3plGeHhyU-V2aeqPA_aZH-hcDXm7YuMabTGJq63gkA/exec', {
        method: 'POST',
        body: JSON.stringify(order)
      })
      
      alert(`Order placed successfully! Total: Rs. ${grandTotal.toLocaleString()} (Rs. 6,000 for dress + Rs. 300 delivery). We will contact you soon.`)
      navigate('/')
    } catch (error) {
      alert('Order saved. We will contact you soon.')
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-2">Checkout</h1>
      <p className="text-gray-600 mb-8">Complete your order</p>

      <div className="grid md:grid-cols-2 gap-8">
        <div className="bg-white p-6 rounded-2xl shadow-md">
          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div>
                <label className="block font-semibold mb-2">Full Name *</label>
                <input
                  type="text"
                  name="name"
                  value={customer.name}
                  onChange={handleChange}
                  required
                  className="w-full border rounded-lg p-2"
                />
              </div>
              <div>
                <label className="block font-semibold mb-2">Email *</label>
                <input
                  type="email"
                  name="email"
                  value={customer.email}
                  onChange={handleChange}
                  required
                  className="w-full border rounded-lg p-2"
                />
              </div>
              <div>
                <label className="block font-semibold mb-2">Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={customer.phone}
                  onChange={handleChange}
                  required
                  placeholder="03XX 1234567"
                  className="w-full border rounded-lg p-2"
                />
              </div>
              <div>
                <label className="block font-semibold mb-2">Delivery Address *</label>
                <textarea
                  name="address"
                  value={customer.address}
                  onChange={handleChange}
                  required
                  className="w-full border rounded-lg p-2"
                  rows="2"
                  placeholder="House #, Street, City, Postal Code"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-rose-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-rose-700 transition mt-6 disabled:opacity-50"
            >
              {loading ? 'Placing Order...' : `Place Order • Rs. ${grandTotal.toLocaleString()}`}
            </button>
          </form>
        </div>

        <div className="bg-rose-50 p-6 rounded-2xl h-fit">
          <h3 className="font-bold text-lg mb-4">Order Summary</h3>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span>Dress:</span>
              <span className="font-semibold">{dress?.name}</span>
            </div>
            <div className="flex justify-between">
              <span>Fabric:</span>
              <span>{fabric?.name || 'Linen/Cotton'}</span>
            </div>
            <div className="flex justify-between">
              <span>Sleeve:</span>
              <span>{sleeve?.name}</span>
            </div>
            <div className="flex justify-between">
              <span>Length:</span>
              <span>{length?.name}</span>
            </div>
            <div className="border-t pt-2 mt-2">
              <div className="flex justify-between">
                <span>Dress Price:</span>
                <span>Rs. {(totalPrice || 6000).toLocaleString()}</span>
              </div>
              <div className="flex justify-between">
                <span>Delivery Charges:</span>
                <span>Rs. {deliveryCharges.toLocaleString()}</span>
              </div>
            </div>
            <div className="border-t pt-2 mt-2">
              <div className="flex justify-between font-bold text-lg">
                <span>Total:</span>
                <span className="text-rose-700">Rs. {grandTotal.toLocaleString()}</span>
              </div>
            </div>
          </div>
          <div className="mt-6 p-3 bg-white rounded-lg text-xs text-gray-500">
            <p>✅ Rs. 6,000 for dress</p>
            <p>✅ Rs. 300 delivery charges</p>
            <p>✅ Made to your measurements</p>
          </div>
        </div>
      </div>
    </div>
  )
}
